import { useEffect } from 'react';

export const useScrollToTop = (...dependencies: unknown[]) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies]);
};
